/**
 * Formats a date as relative time (e.g., "5m ago", "2d ago")
 * @param date - Date to format
 * @param options - Formatting options
 * @returns Formatted relative time string
 */
export function timeAgo(date: Date | string, options?: { justNow?: boolean }): string {
  const now = new Date();
  const past = new Date(date);
  const seconds = Math.floor((now.getTime() - past.getTime()) / 1000);

  if (seconds < 60) {
    return options?.justNow ? 'just now' : `${seconds}s ago`;
  }

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;

  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;

  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo ago`;

  const years = Math.floor(months / 12);
  return `${years}y ago`;
}

/**
 * Alias for timeAgo with "just now" for recent times
 * @param date - Date to format
 * @returns Formatted relative time string (e.g., "just now", "5m ago")
 */
export function formatTimeAgo(date: Date | string): string {
  return timeAgo(date, { justNow: true });
}